import React, { useState } from "react";
import { PieChart, Pie, Sector, ResponsiveContainer, Tooltip } from "recharts";

import { BaseDropdown } from "@components/library/UI/BaseDropdown";

import { ReactComponent as ArrowIcon } from "@assets/images/icons/arrow-down-icon.svg";

import "./AssetPreferences.sass";

const assetData = [
  {
    name: "ETH",
    color: "#FF4782",
    percentage: 32.85,
    cost: "$2,150.00",
    amount: "1.52 ETH",
    pnl: "+10.45%",
  },
  {
    name: "SOL",
    color: "#23C381",
    percentage: 22.45,
    cost: "$98.20",
    amount: "4.87 SOL",
    pnl: "+12.10%",
  },
  {
    name: "BTC",
    color: "#8E59FF",
    percentage: 15.73,
    cost: "$41,550.00",
    amount: "0.082 BTC",
    pnl: "+6.15%",
  },
  {
    name: "FHE",
    color: "#3892FF",
    percentage: 13.8,
    cost: "$3.45",
    amount: "52.1 FHE",
    pnl: "-7.90%",
  },
  {
    name: "IP",
    color: "#F6BA47",
    percentage: 2.13,
    cost: "$1.12",
    amount: "190 IP",
    pnl: "+5.80%",
  },
  {
    name: "OTHER",
    color: "#FF6C22",
    percentage: 1.84,
    cost: "—",
    amount: "—",
    pnl: "—",
  },
];

export const AssetPreferences = () => {
  const [period, setPeriod] = useState("30 Days");

  return (
    <div className="asset-preferences">
      {/* 1. HEADER */}
      <div className="asset-preferences__header">
        <h2 className="asset-preferences__title">Asset Preferences</h2>
        <BaseDropdown
          trigger={
            <button className="asset-preferences__dropdown-btn">
              {period} <ArrowIcon />
            </button>
          }
        >
          {({ closeDropdown }) => (
            <div className="asset-preferences__dropdown-menu">
              {["7 Days", "30 Days", "90 Days"].map((opt) => (
                <div
                  key={opt}
                  className="asset-preferences__dropdown-item"
                  onClick={() => {
                    setPeriod(opt);
                    closeDropdown();
                  }}
                >
                  {opt}
                </div>
              ))}
            </div>
          )}
        </BaseDropdown>
      </div>

      {/* 2. CONTENT */}
      <div className="asset-preferences__content">
        <div className="asset-preferences__chart">
          <ResponsiveContainer width="100%" height={170}>
            <PieChart>
              <Pie
                data={assetData}
                dataKey="percentage"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={65}
                outerRadius={85}
                stroke="none"
                // The new Recharts 4.0 compliant way to color slices!
                shape={(props) => (
                  <Sector {...props} fill={props.payload.color} />
                )}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#23262F",
                  borderColor: "#363636",
                  borderRadius: "8px",
                  color: "#fff",
                }}
                itemStyle={{ color: "#fff" }}
                formatter={(value) => `${value}%`}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* DATA TABLE */}
        <div className="asset-preferences__table-wrapper">
          <table className="asset-preferences__table">
            <thead>
              <tr>
                <th>Crypto</th>
                <th>Percentage</th>
                <th>Cost price</th>
                <th>Amount</th>
                <th>PNL</th>
              </tr>
            </thead>
            <tbody>
              {assetData.map((asset, i) => {
                const isNegative = asset.pnl.startsWith("-");
                const isNeutral = asset.pnl === "—";

                return (
                  <tr key={i}>
                    <td className="asset-preferences__cell-crypto">
                      <span
                        className="asset-preferences__dot"
                        style={{ backgroundColor: asset.color }}
                      ></span>
                      {asset.name}
                    </td>
                    <td>{asset.percentage}%</td>
                    <td>{asset.cost}</td>
                    <td>{asset.amount}</td>
                    <td
                      className={`
                      ${
                        isNegative
                          ? "asset-preferences__cell-pnl--negative"
                          : ""
                      } 
                      ${
                        !isNegative && !isNeutral
                          ? "asset-preferences__cell-pnl--positive"
                          : ""
                      }
                      ${isNeutral ? "asset-preferences__cell-pnl--neutral" : ""}
                    `}
                    >
                      {asset.pnl}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
